import { render, staticRenderFns } from "./AdminMandateTypesSearch.vue?vue&type=template&id=8640a5d2&"
import script from "./AdminMandateTypesSearch.vue?vue&type=script&lang=js&"
export * from "./AdminMandateTypesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports